/**
 * Default: Vendors > Brand endorsement
 */

import {setRootVar} from "@ifabnpm/bootstrap/utils.js";

import SelectorEngine from '@ifabnpm/bootstrap/dom/selector-engine.js';

const init = async () => {
	const endorsement = SelectorEngine.findOne('.leipzig-brand-endorsement');

	if (endorsement) {
		setRootVar('brand-endorsement-height', `${endorsement.offsetHeight}px`);
	}
};

// Export
export default init;
